export default __webpack_public_path__ + "static/media/InfoLetterI.6a68eb63.svg";